<template>
  <el-dialog :close-on-click-modal="false" append-to-body title="添加产品" :visible.sync="addProDialog" width="1000px" @closed="closed">
    <!-- 第一步 -->
    <el-container v-show="step === 1">
      <el-aside width="200px">
        <el-tree v-if="addProDialog" ref="tree" :props="defaultProps" node-key="value" :load="loadNode" lazy @node-click="handleNodeClick"></el-tree>
      </el-aside>
      <el-container>
        <el-header style="height:30px;">
          <span style="margin:0 10px 0 20px;font-weight: 700;color: #666666;">产品名称:</span>
          <el-input v-model="spuVO.spuName" style="width:180px;" placeholder=""></el-input>
          <el-button style="float:right;margin-right:20px;" round @click="handleNodeClick">查询</el-button>
        </el-header>
        <el-main>
          <div class="pro_box" @click="getSpuDetail(pro)" v-for="pro in spuList" :key="pro.id">
            <el-image style="width: 98px; height: 98px" :src="pro.spuImage + '?x-sds-process=image/resize,l_98,m_mfit'" fit="cover"></el-image>
            <p>{{ pro.spuName }}</p>
          </div>
        </el-main>
        <el-footer>
          <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
        </el-footer>
      </el-container>
    </el-container>
    <!-- 第二步 -->
    <el-form ref="form" label-width="150px" v-show="step === 2">
      <el-form-item label="价格信息:">
        <el-table :data="spuSkuGroupList" border style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-table :data="scope.row.skuList" border style="width: 100%">
                <el-table-column label="SKU名称" prop="skuName"></el-table-column>
                <!-- <el-table-column label="SKU前端显示名称" prop="skuFrontName"></el-table-column> -->
                <el-table-column label="基础P数" prop="basePage"></el-table-column>
                <el-table-column label="最大P数" prop="maxPage"></el-table-column>
                <el-table-column label="一次增加P数" prop="baseStep"></el-table-column>
                <el-table-column label="基础P平台价格" prop="basePagePrice"></el-table-column>
                <el-table-column label="增加一次平台价格" min-width="130px" prop="baseStepPrice"></el-table-column>
                <el-table-column label="基础P在线支付价格" min-width="130px" prop="onlineSalePrice"></el-table-column>
                <el-table-column label="增加一次在线支付价格" min-width="130px" prop="onlineBaseStepPrice"></el-table-column>
                <el-table-column label="基础P推荐终端价格" min-width="130px" prop="terminalSalePrice"></el-table-column>
                <el-table-column label="增加一次推荐终端价格" min-width="130px" prop="terminalStepSalePrice"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="SKU组" prop="skuGroupName"></el-table-column>
          <el-table-column label="属性组和" prop="dictSet"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color_blue" v-show="scope.row.onSale">上架</span>
              <span class="color_blue" v-show="!scope.row.onSale">下架</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="产品主图:" prop="spuImageList">
        <el-image v-for="img in spuDetail.spuImageList" :key="img" style="width: 100px; height: 100px" :src="img + '?x-sds-process=image/resize,l_98,m_mfit'"
          :preview-src-list="spuDetail.spuImageList">
        </el-image>
      </el-form-item>
      <el-form-item label="产品详情:" prop="pcDetail">
        <div class="product-img ql-editor" v-html="spuDetail.pcDetail"></div>
      </el-form-item>
      <el-form-item>
        <el-button round style="margin-left:600px;" @click="step = 1">上一步</el-button>
        <el-button round @click="getFirstCategoryList(), step = 3">下一步</el-button>
      </el-form-item>
    </el-form>
    <!-- 第三步 -->
    <el-form ref="addPosSpuVO" :model="addPosSpuVO" label-width="80px" v-show="step === 3">
      <el-form-item label="产品类别">
        <el-select v-model="addPosSpuVO.firstCategoryId" placeholder="请选择" @change="getSecondCategoryList" style="margin-right:5px;">
          <el-option v-for="item in firstCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId"></el-option>
        </el-select>
        <el-select v-model="addPosSpuVO.secondCategoryId" placeholder="请选择">
          <el-option v-for="item in secondCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品名称" prop="name">
        <el-input v-model="addPosSpuVO.name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button round style="margin-left:600px;" @click="step = 2">上一步</el-button>
        <el-button round @click="addPro">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>

import VPagination from '@/components/Pagination/index.vue'
import { spuList, posSpuAdd, spuGet, categoryList, posCategoryQueryAllSubs, queryAllSubs, skuGroupListBySpuId, skuGroupDetail, skuList, posCategoryList } from '@/api/pms'

export default {
  components: {
    VPagination
  },
  data () {
    return {
      lock: true,
      tagsId: '',
      storeTypeName: '',
      firstCategoryList: [],
      secondCategoryList: [],
      addPosSpuVO: {
        firstCategoryId: '',
        secondCategoryId: '',
        skuGroups: [
          {
            isSample: true,
            skuGroupId: 0
          }
        ],
        spuId: 0,
        spuName: '',
        name: '',
        tagsId: 0
      },
      step: 1,
      spuSkuGroupList: [],
      spuDetail: {},
      spuList: [],
      spuVO: {
        spuName: '',
        categoryId: ''
      },
      addProDialog: false,
      defaultProps: {
        children: 'children',
        label: 'label',
        isLeaf: 'leaf'
      },
      queryInfo: {
        pageNum: 1,
        pageSize: 24,
        total: 0
      }

    }
  },
  methods: {
    show (tagsId, storeTypeName) {
      this.addProDialog = true
      this.tagsId = tagsId
      this.storeTypeName = storeTypeName
    },
    hide () {
      this.addProDialog = false
      this.step = 1
      this.$emit('fatherMethod')
    },

    addPro () {
      if (this.addPosSpuVO.firstCategoryId === '') {
        this.$message.error('请选择产品类！')
        return
      }
      if (this.addPosSpuVO.secondCategoryId === '') {
        this.$message.error('请选择产品子类！')
        return
      }
      if (this.addPosSpuVO.name === '') {
        this.$message.error('请填写产品名称！')
        return
      }

      let addPosSpuVO = {
        firstCategoryId: this.addPosSpuVO.firstCategoryId,
        secondCategoryId: this.addPosSpuVO.secondCategoryId,
        skuGroups: this.addPosSpuVO.skuGroups.reduce((list, item) => {
          list.push({
            isSample: item.onSale,
            skuGroupId: item.id
          })
          return list
        }, []),
        spuId: this.addPosSpuVO.spuId,
        spuName: this.addPosSpuVO.name,
        tagsId: this.tagsId
      }

      const loading = this.$loading({
        lock: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      posSpuAdd(addPosSpuVO)
        .then(res => {
          loading.close()
          if (res.data.success) {
            this.$message.success('添加成功')
            this.hide()
          }
        })
    },
    getSecondCategoryList (value) {
      this.addPosSpuVO.secondCategoryId = ''
      posCategoryQueryAllSubs(value).then(res => {
        if (res.data.success) {
          this.secondCategoryList = res.data.data.subCategoryList
        }
      })
    },
    getFirstCategoryList () {
      posCategoryList(this.tagsId)
        .then(res => {
          if (res.data.success) {
            this.firstCategoryList = res.data.data
          }
        })
    },
    getSkuGroupMsg () {
      skuGroupDetail().then(res => {
        if (res.data.success) {
          let list = res.data.data
          list.skuList = list.skuList.filter(sku => {
            return !sku.isSample
          })
          // 处理属性
          list.dictList = []
          let dict = list.dictSet.split(';')
          dict.pop()
          dict.forEach(item => {
            item = item.split(':')
            list.dictList.push(item)
          })
          // list.dictSet
          this.basicInfo = list
        }
      })
    },
    getSpuDetail (spu) {
      console.log(spu)
      this.addPosSpuVO.spuId = spu.id
      spuGet(spu.id)
        .then(res => {
          if (res.data.success) {
            this.spuDetail = res.data.data

            skuGroupListBySpuId({ spuId: spu.id, pageNum: 1, pageSize: 100 }).then((res) => {
              if (res.data.success) {
                this.addPosSpuVO.skuGroups = res.data.data.records
                this.spuSkuGroupList = res.data.data.records.filter(sku => {
                  return !sku.isSample
                })

                this.spuSkuGroupList.forEach(item => {
                  skuList(item.id)
                    .then(res => {
                      if (res.data.success) {
                        item.skuList = res.data.data
                      }
                    })
                })
                this.step = 2
              }
            })
          }
        })
    },
    changePage (val) {
      this.queryInfo = val
      this.handleNodeClick()
    },
    handleNodeClick (data) {
      if (data) {
        this.spuVO.categoryId = data.value
      }
      spuList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, spuVO: this.spuVO })
        .then((res) => {
          if (res.data.success) {
            this.spuList = res.data.data.records
            this.queryInfo.total = res.data.data.total
          }
        })
    },
    loadNode (node, resolve) {
      let { level } = node
      if (level === 0) {
        categoryList().then(res => {
          let nodes = []
          res.data.data.forEach(item => {
            if (item.categoryName === this.storeTypeName || item.categoryName === '通用') {
              nodes.push({
                value: item.id,
                label: item.categoryName,
                leaf: item.bottom || item.id === 4
              })
            }
            // return {
            //   value: item.id,
            //   label: item.categoryName,
            //   leaf: item.bottom || item.id === 4
            // }
          })
          resolve(nodes)
        })
      } else if (level === 1) {
        let { value } = node.data
        queryAllSubs(value).then(res => {
          let nodes = res.data.data.subCategoryList.map(item => {
            return {
              value: item.id,
              label: item.categoryName,
              leaf: item.subCategoryList.length === 0,
              subCategoryList: item.subCategoryList
            }
          })
          resolve(nodes)
        })
      } else {
        let nodes = node.data.subCategoryList.map(item => {
          return {
            value: item.id,
            label: item.categoryName,
            leaf: item.subCategoryList.length === 0,
            subCategoryList: item.subCategoryList
          }
        })
        resolve(nodes)
      }
    },
    closed () {
      this.step = 1
      this.$nextTick(_ => {
        this.spuList.length = 0
        this.queryInfo.pageNum = 1
        this.queryInfo.total = 0
        this.addPosSpuVO.firstCategoryId = ''
        this.addPosSpuVO.secondCategoryId = ''
        this.$refs.form.resetFields()
        this.$refs.addPosSpuVO.resetFields()
      })
    }

  }
}
</script>

<style lang="less" scoped>
@deep: ~ '>>>';

@{deep} .el-dialog__title {
  color: #666666;
  font-weight: 600;
  font-style: normal;
  font-family: "思源黑体 Bold", "思源黑体 Regular", "思源黑体 CN Regular", sans-serif;
  font-kerning: normal;
  font-size: 16px;
}

.el-container {
  height: 500px;

  .el-aside {
    border-right: 1px solid #ccc;
    width: 180px;
  }
}

.pro_box {
  width: 98px;
  float: left;
  border: 1px solid #ccc;
  margin-right: 20px;
  margin-bottom: 10px;
  cursor: pointer;

  &:nth-of-type(6n) {
    margin-right: 0px;
  }

  p {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
